"use client";
import { useCallback } from "react";

export const useCostLog = ({ values }) => {
  const cost = useCallback(
    (yearCount = 1) => {
      if (yearCount == 1) {
        return values?.cost;
      }
      return values?.cost + values?.renewal * (yearCount - 1);
    },
    [values]
  );

  return { cost };
};
